import type { IconSvgObject } from './types';

const AddTeam02Icon: IconSvgObject = [
  ["path", { d: "M3 20V16.9852C3 16.364 3.28162 15.7658 3.81618 15.4494C5.34261 14.546 7.32863 14 9.5 14C10.7448 14 11.9287 14.1795 13 14.5028", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 14V20M15 17H21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "9.5", cy: "7.5", r: "3.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14.5 4.14453C15.9457 4.57481 17 5.91408 17 7.49959C17 9.0851 15.9457 10.4244 14.5 10.8547", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default AddTeam02Icon;
